import { render } from "./Eleicoes.vue?vue&type=template&id=6339939b&scoped=true"
import script from "./Eleicoes.vue?vue&type=script&lang=js"
export * from "./Eleicoes.vue?vue&type=script&lang=js"

import "./Eleicoes.vue?vue&type=style&index=0&id=6339939b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6339939b"]])

export default __exports__